import { actionNames, GLOBAL_STATE } from '../constants/actionTypes'
import { createReduxEssentials } from '../../../helpers/createReduxEssentials'

const { reducer, actionTypes, actions, selectors } = createReduxEssentials(actionNames, GLOBAL_STATE)

export const CHAT = GLOBAL_STATE

export { reducer, actionTypes, actions, selectors }
